import get from 'lodash.get';
import { getEverLoggedIn } from 'dibs-cookie-jar';
import { graphql, fetchQuery } from 'react-relay';

// helpers
import { wasPdpVisitedMultipleTimes } from '../pdpSharedNotificationHelpers';
import { getItemIdFromUri } from '../../../utils/getItemIdFormUri';
import { setModalShown, wasModalShown } from 'dibs-buyer-layout/exports/autoModalHelper';
import { PRIORITIES, SHOW_MULTI_PDP_VISITS } from '../pdpSharedNotificationConstants';

/**
 * Callout Workflow
 * 1. Check user, if modal has ever been displayed and registration limit. Returns true if:
 *    - User has never logged in.
 *    - Multiple Pdp visit modal has never been displayed.
 *    - Pdp page has been visited at least three times in current session.
 *
 * 2. If step 1 returns true, check item.
 *    - If item is available and not on sale return true
 */

const { MULTI_PDP_VISITS: MULTI_PDP_VISITS_PRIORITY } = PRIORITIES;

const query = graphql`
    query pdpSharedNotificationMultiplePdpVisitsModalConfigQuery($itemId: String = "") {
        viewer {
            item(itemId: $itemId, pageType: PDP) {
                status
                pricing {
                    bargain
                }
            }
        }
    }
`;

export const pdpSharedNotificationMultiplePdpVisitsModalConfig = {
    name: 'saveToFolderCallout',
    priority: MULTI_PDP_VISITS_PRIORITY,

    rule: ({ relayEnvironment }) => {
        const itemId = getItemIdFromUri(location.pathname);

        if (!itemId) {
            // could not get a item Id, exit out
            return Promise.resolve(false);
        }

        /**
         * MODAL_TYPE_AUTO is inactive to activate it again replace wasPdpVisitedMultipleTimes
         * with canShowAutoModal from ./pdpSharedNotificationMultiplePdpVisitsModalHelpers
         */
        if (
            getEverLoggedIn(document.cookie) ||
            wasModalShown() ||
            !wasPdpVisitedMultipleTimes({ itemId })
        ) {
            return Promise.resolve(false);
        }

        return fetchQuery(relayEnvironment, query, { itemId }).then(response => {
            const bargain = get(response, 'viewer.item.pricing.bargain');
            const status = get(response, 'viewer.item.status');

            if (bargain || status === 'UNAVAILABLE') {
                return false;
            }
            return true;
        });
    },

    action: () => dispatch => {
        setModalShown();
        dispatch({
            type: SHOW_MULTI_PDP_VISITS,
        });
    },
};
